import { numberToPrettyString } from '@cian/utils';
import { NBSP } from '../../../constants/symbols';

interface IParams {
  balance: number;
  auctionPoints: number | null;
  isShowAgencyBalance: boolean;
}

export const getBalanceString = (params: IParams): string | null => {
  const { balance, auctionPoints, isShowAgencyBalance } = params;

  if (!isShowAgencyBalance) {
    return null;
  }

  const formattedBalance = numberToPrettyString(Number(balance));

  return [`${formattedBalance}${NBSP}₽`, auctionPoints && `${numberToPrettyString(auctionPoints)}${NBSP}Б`]
    .filter(Boolean)
    .join(' и ');
};
